import { SettingConst } from '@faire/web-api--source/types';

/**
 * Redesign brand page header to make it more condensed
 */
export const CONDENSED_BRAND_PAGE_HEADER_TEST_XP_241118 =
  'CONDENSED_BRAND_PAGE_HEADER_TEST_XP_241118' as SettingConst<
    'CONDENSED_BRAND_PAGE_HEADER_TEST_XP_241118',
    boolean,
    'RETAILER' | 'RETAILER_ANDROID' | 'RETAILER_IOS' | 'VISITOR_WEB'
  >;
